export default {
    CHECKING_ACCOUNT: { id: 1, type: '300', subtype: '800', standar: '0000001', language: '1' },
    OPEN_DEBIT: { id: 2, type: '506', subtype: '002', standar: '0000020', language: '1' },
    NOMINA: { id: 2, type: '300', subtype: '805', standar: '0000001', language: '1' },
    WELCOME: { id: 2, type: '301', subtype: '7', standar: '0000009', language: '1' },
};
